<template>
  <ul style="list-style: none;">
    <li class="pt-4 pb-4"><a target="_blank" :href="googlePlayLink"><img width="200px"
                                                                         src="/img/emails/mobile/google-play-badge.png"
                                                                         alt="Google Play"></a></li>
    <li v-if="appStoreLink"><a target="_blank" :href="appStoreLink"><img width="200px"
                                                                         src="/img/emails/mobile/app_store.png"
                                                                         alt="App Store"/></a></li>

  </ul>
</template>
<script>
export default {
  props: {
    appStoreLink: String,
    googlePlayLink: String,
  }
}
</script>
